import React from 'react';
import { FormBehavior } from './index';
import { toast } from '@/components/ui/toast';
import carePlanTemplate from '../templates/careplan.json';

interface CarePlanHeaderProps {
  importPreviousCarePlan: () => void;
  isAltView: boolean;
  setIsAltView: (value: boolean) => void;
}

const CarePlanHeader: React.FC<CarePlanHeaderProps> = ({ 
  importPreviousCarePlan, 
  isAltView, 
  setIsAltView 
}) => {
  return (
    <div className="grid grid-cols-3 gap-2 pt-4">
      <button 
        onClick={importPreviousCarePlan}
        className="px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600"
      >
        Import Previous Care Plan
      </button>
      <div/>
      <button
        onClick={() => setIsAltView(!isAltView)}
        className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded hover:bg-gray-300"
      >
        {isAltView ? 'Full Care Plan' : 'Mini Care Plan View'}
      </button>
    </div>
  );
};

export const carePlanBehavior: FormBehavior = {
  renderHeader: (props) => (
    <React.Fragment/>
  ),
  
  getTemplate: (templateData, isAltView) => {
    return JSON.stringify(carePlanTemplate);
  },
  
  getInitialData: (props) => {
    const { participant, user } = props;
    return {
      member_name: participant?.name ? `${participant.name.firstName} ${participant.name.lastName}`.trim() : '',
      cin_number: participant?.cin || '',
      leadcaremanager_name: user?.realname || ''
    };
  },
  
  supportsAltTemplate: true,
  
  customActions: [
    {
      label: 'Import Previous',
      action: (props) => props.importPreviousCarePlan(),
      variant: 'secondary'
    }
  ],
  
  customLogic: {
    onBeforeCreate: (data) => {
      // Any care plan specific validation before creation
      return data;
    },
    
    onAfterLoad: (data) => {
      // Any care plan specific processing after loading
      return data;
    }
  }
};